import { Component, OnInit, OnDestroy } from '@angular/core';
import { GroupsService } from '../services/groups.service';
import { takeUntil } from 'rxjs/operators';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';

@Component({
    styles: [`
        group-summary {
            padding: 8px;
        }
        .back-link {
            padding-bottom: 12px;
        }

        .trim-container {
           min-width: 0px;
        }
        
        .image-row {
            min-height: 88px;
        }

        .description {
            padding-bottom: 10px;
            height: 49px; 
            overflow: hidden;
        }
        
        .user-count {
            padding-left: 5px; 
            padding-right: 8px;
        }
        
        .item-count {
            padding-left: 15px;
            padding-right: 8px;
        }
        
        .count-wrapper {
            display: inline-block;
            padding-right: 15px;
        }

        .count {
            font-align: center;
        }

        h4 {
            margin-top: 0px;
            margin-bottom: 0px;
        }
    `],
    template: `
        <div *ngIf="!groups" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner></spinner>
        </div>
        <mat-grid-list [cols]="columnCount" *ngIf="groups && groups.length" rowHeight="200px" style="margin-top: 20px;">
            <mat-grid-tile *ngFor="let group of groups" fxLayoutAlign="center center">
                <group-summary style="width: 100%" [group]="group"></group-summary>    
            </mat-grid-tile>
        </mat-grid-list>
        <div *ngIf="groups && !groups.length && emptyMessage" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <h4>{{emptyMessage}}</h4>
        </div>
    `
})
export class BrowseGroupsListComponent implements OnInit, OnDestroy {
    private cleanupTime = new Subject<void>();
    columnCount: number;
    groups: any[];
    emptyMessage = 'No Groups Available';

    constructor(private media: MediaObserver, private groupService: GroupsService) {}

    ngOnInit(): void {
        const count = () => this.columnCount = this.media.isActive('xs') || this.media.isActive('sm') ? 1 : (this.media.isActive('md') ? 2 : 3);
        this.media.media$.pipe(takeUntil(this.cleanupTime)).subscribe(() => count());
        count();
        this.groupService.fetchGroups({ page: 0, rows: 300, allowUsersToJoin: true }).subscribe(response => this.groups = response.content);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}    